<template>
    <textarea
        ref="input"
        v-model="model"
        class="tw-text-sm tw-resize-none tw-border tw-border-gray-300 tw-bg-white tw-w-full tw-px-3.5 tw-py-1.5 tw-rounded-md tw-text-gray-900 tw-transition-colors tw-duration-150 hover:tw-border-gray-400 focus:tw-border-gray-600 focus:tw-ring-0 focus:tw-outline-none placeholder:tw-text-gray-400"
        :rows
        :cols="props.cols ? props.cols : undefined"
        :maxlength
        :placeholder
        :disabled
        :readonly="props.readonly ? props.readonly : undefined"
        :wrap="wrap"
    ></textarea>
</template>
<script setup lang="ts">
import { inject, onMounted, useTemplateRef, watch } from 'vue';

const props = defineProps({
    rows: {
        type: [String, Number],
        default: 1,
    },
    cols: {
        type: [String, Number],
        required: false,
    },
    expandable: {
        type: Boolean,
        default: false,
    },
    maxlength: {
        type: [Number, String],
        required: false,
    },
    placeholder: {
        type: String,
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    wrap: {
        type: String,
        default: 'soft',
    },
    readonly: {
        type: Boolean,
        default: false,
    },
});

const input = useTemplateRef('input');
const model = defineModel<string | null>({
    type: String,
    default: '',
});

const resizeExpandableInput = () => {
    if (!props.expandable || !input.value) {
        return;
    }
    const inputEl = input.value;
    inputEl.style.height = 'auto';
    inputEl.style.height = `${inputEl.scrollHeight + 2}px`;
};

/**
 * If this component is used in a tab, we need to inject the activeTab context
 * as if the tab this is within isn't displayed by default, the onMounted hook
 * will still get called but not adequately resize the textarea.
 */
const activeTabContext = inject('activeTab', false);
if (activeTabContext) {
    watch(activeTabContext, () => {
        setTimeout(() => {
            resizeExpandableInput();
        }, 5);
    });
}

onMounted(() => {
    setTimeout(() => resizeExpandableInput(), 10);
});

watch(model, () => {
    resizeExpandableInput();
});

defineExpose({
    model,
});
</script>
